<template>
    <div id="BimbinganAkademik">
        <div class="r-option-place r-center-flex" style="flex-wrap : wrap;">
            <div class="y-inputField">
                <div class="y-hasIcon-right y-md-size">
                    <input type="text" 
                        v-model="request.search" 
                        @keyup="setTime()" 
                        @keydown="clearTime()" 
                        @keydown.tab="setTime()" 
                        @keyup.tab="clearTime()" 
                        @keypress.enter="getData()" 
                        placeholder="Search . . ."
                    >
                    <div class="y-inputIcon r-center-flex">
                        <img :src="require('@/assets/icons/others/search.svg')" alt="">
                    </div>
                </div>
            </div>
            <div class="y-inputField">
                <div class="y-hasIcon-right y-md-size">
                    <div class="r-dropdown r-dropdown-inputStyle r-center-flex" @click.prevent="dropdown = !dropdown">
                        <p style="margin-right: auto;padding-right: 10px;">{{semester}}</p>
                        <img :src="require('@/assets/icons/others/dropdown-arrow.svg')" alt="">
                        <div class="r-dropdown-items" style="margin-top: -10px;width: 155px;" :style=" dropdown? '' : 'display: none'">
                            <div class="r-dropdown-item r-center-flex" v-for="sem in semestersData" :key="`sem-${sem.id}`" @click.prevent="setSemester(sem)">{{sem.name + " - " + sem.type}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="r-lecture-namePlace r-center-flex y-md-size" style="margin-right: auto;">
                <p class="r-center-flex y-ellipsis">
                    Mahasiswa {{tempName}}
                </p>
            </div>
        </div>
        <div class="r-table">
            <table>
                <caption>
                <div class="y-inputField" style="margin-right: auto;">
                    <div class="y-hasIcon-right y-md-size">
                        <input type="text" v-model="dataLabel[request.sortBy]" readonly @click="showThead = !showThead" placeholder="Urut Berdasarkan">
                    </div>
                </div>
                </caption>
                <thead>
                <tr class="hideThead" :class="showThead ? 'showThead' : ''">
                    <th class="r-table-firstColumn">No</th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('created_at')" :class="request.sortBy == 'created_at' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Tanggal Bimbingan</span> <img :style="request.sortBy == 'created_at' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'created_at' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th class="r-table-unsortable">Status Pesan</th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('type')" :class="request.sortBy == 'type' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Tipe Bimbingan</span> <img :style="request.sortBy == 'type' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'type' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('status')" :class="request.sortBy == 'status' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Status Bimbingan</span> <img :style="request.sortBy == 'status' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'status' ? 'blue' : 'gray'}.svg`)"> </div></th>
                </tr>
                </thead>
                <loading v-if="fetchData"/>
                <nodata v-if="guidances.length == 0"></nodata>
                <tr v-for="(guidance, index) in guidances" :key="`guidances-${index}`" @click.prevent="giveResponse(guidance.id)">
                    <td data-label="No" class="r-table-firstColumn" >{{curNumber(index)}}</td>
                    <td data-label="Tanggal Bimbingan" >{{convertDateTime(guidance.created_at)}}</td>
                    <td data-label="Status Pesan" >
                            <p class='y-alert y-alert-warning' v-if="guidance.lastSenderId != userId && guidance.status == 0">Memiliki Pesan baru</p>
                            <p class='y-alert y-alert-primary' v-if="guidance.lastSenderId == userId && guidance.status == 0">Menunggu Balasan</p>
                            <p class='y-alert y-alert-success' v-if="guidance.status == 1">Bimbingan Selesai</p>
                            </td>
                    <td data-label="Tipe Bimbingan" ><p class="y-alert" :class="guidance.type == 'Offline' ? 'y-alert-warning' : 'y-alert-success'">{{guidance.type}}</p></td>
                    <td data-label="Status Bimbingan" ><p class="y-alert" :class="guidance.status == 0 ? 'y-alert-error' : 'y-alert-success'">
                        {{guidance.status == 0 ? 'Belum dikonfirmasi' : 'Dikonfirmasi'}}</p></td>
                </tr>
            </table>
            <div class="r-table-pagination">
                <div class="r-pagination r-center-flex r-isWrap">
                    <div class="r-mr-auto r-center-flex r-mt-10">
                        <span>Data per halaman: </span> 
                        <div class="r-autocomplete2"  @click.prevent="pageDropdown = !pageDropdown">
                            <p class="r-inputStyle r-ptb-4 r-plr-12 r-mlr-10">{{request.show}}</p>
                            <div class="r-autocomplete2-place" v-if="pageDropdown" @mouseleave="pageDropdown = false">
                                <div class="r-autocomplete2-items">
                                        <div class="r-autocomplete2-item" @click.prevent="setShow(10)" >10</div>
                                        <div class="r-autocomplete2-item" @click.prevent="setShow(25)" >25</div>
                                        <div class="r-autocomplete2-item" @click.prevent="setShow(50)" >50</div>
                                        <div class="r-autocomplete2-item" @click.prevent="setShow(100)" >100</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="r-ml-auto r-center-flex r-mt-10">
                        <span>{{data.from == null ? 0 : data.from}} - {{data.to == null ? 0 : data.to}} dari {{data.total == null ? 0 : data.total}}</span>
                        <div class="r-pagination-movebutton r-center-flex">
                            <input type="image" :src="require('@/assets/icons/others/arrow-left.svg')" :disabled="request.page < 2" @click.prevent="getData(-1)">
                            <input type="image" style="transform: rotate(180deg)" :src="require('@/assets/icons/others/arrow-left.svg')" :disabled="request.page >= data.last_page" @click.prevent="getData(1)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="r-modal" v-if="modal">
            <div class="r-box"> 
                <div class="r-header">
                    <h1>Preview Bimbingan</h1>
                </div>
                <div class="r-body">
                    <h2>Masalah Bimbingan</h2>
                    <div class="r-modal-content" v-html="problem"></div>
                </div>
                <div class="r-footer r-center-flex">
                    <button class="y-hasspace-btn y-sm-size" style="margin-left: auto" @click.prevent="modal = false; problem = '';problemId = -1">
                        Tutup
                    </button>
                    <button class="y-primary-btn y-hasspace-btn y-sm-size" style="margin-left: auto" @click.prevent="giveResponse(problemId)">
                        Tanggapi
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import common from '@/mixins/function/common'
import tableMethods from '@/mixins/tableMethods'
export default {
    mixins: [common, tableMethods],
    components:{
        'loading' : () => import( /* webpackChunkName: "loading" */ `@/components/common/loading.vue`),
        'nodata' : () => import( /* webpackChunkName: "nodata" */ `@/components/common/nodata.vue`)
    },

    async mounted() {
        await this.$store.restored
        if(this.role == 'mahasiswa'){
            this.setActiveTab("Kewirausahaan")
        }else{
            this.setActiveTab('Bimbingan')
        }
        var breadcrumb = [
            {
                name: "Bimbingan Kewirausahaan",
                link: {name: 'MyGuidanceStudentsKewirausahaan'},
                current: false
            },
            {
                name: 'List Bimbingan Kewirausahaan',
                link: {},
                current: true
            }
        ]
        this.setBreadCrumb(breadcrumb)
        this.getData()
    },
    computed:{
        ...mapGetters ({
            semesters: "semester/getSemesters",
            userId: "auth/getId",
            selectedSemester: "auth/getSemester",
            request: "guidanceKewir/getRequest",
            data: "guidanceKewir/getData",
            // student: "guidance/getStudent",
            tempName: 'auth/getTempName',
        }),
        semestersData(){
            return this.semesters.filter(row => {
                if(row.id == this.selectedSemester){
                    this.semester = row.name + " - " + row.type
                }
                return true;
            })
        },
        guidances() {
            return this.data?.data || []
        },
    },
    data: () => ({
        dataLabel:{
            created_at: 'Tanggal Pembuatan',
            type: 'Tipe Bimbingan',
            status: 'Status Bimbingan',
        },
        showThead: false,
        modal: false,
        problem: '',
        problemId: -1,
        popup: -1,
        dropdown: false,
        pageDropdown: false,
        nodataState: false,
        fetchData: false,
        semester: null,
    }),
    methods:{
        ...mapActions ({
            getDataFromStudent: "guidanceKewir/getDataBimbinganMahasiswa",
            setRequest: "guidanceKewir/setRequest",
        }),
        giveResponse(id){
            this.$router.push({name: 'ResponseMyStudentGuidanceKewirausahaan', params: {guidance_id: id, student_id : this.$route.params.student_id}})
        },
        setSemester(value){
            this.request.semester = value.id
            this.semester = value.name + " - " + value.type
            this.getData()
        },
        setTime() {
            this.fetchData = true
            clearTimeout(this.typingTimer);
            this.typingTimer = setTimeout(this.getData, 1000);
        },
        clearTime() {
            clearTimeout(this.typingTimer);
        },
        async getData(type = 0) {
            this.fetchData = true
            if(type === 0){
                this.request.page = 1
            }else{
                this.request.page += type
            }
            await this.getDataFromStudent(this.$route.params.student_id)
            this.fetchData = false
            var response = this.getResponse('guidanceKewir')
            if(response.status == 0){
                this.nodataState = true;
                this.showSnackbar ({
                    type: "error",
                    text: response.msg
                })
            }
        },
    }
};
</script>